module.exports = __webpack_public_path__ + "static/img/dry-skin-01.ec0a8f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/assessment/dry-skin-01.jpg
// module id = 263
// module chunks = 1